import { render } from "./admin-list-page.vue?vue&type=template&id=6ea2bc44&scoped=true"
import script from "./admin-list-page.vue?vue&type=script&lang=js"
export * from "./admin-list-page.vue?vue&type=script&lang=js"

import "./admin-list-page.vue?vue&type=style&index=0&id=6ea2bc44&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2bc44"]])

export default __exports__